import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/apiClient";
import { setupAdminPushNotifications } from "../lib/pushNotifications";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("kelifa_token");
    if (!token) { setUser(false); setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        setupAdminPushNotifications();
      })
      .catch(() => { localStorage.removeItem("kelifa_token"); setUser(false); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("kelifa_token", data.access_token);
    setUser(data.user);
    setupAdminPushNotifications();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("kelifa_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
